import { render, staticRenderFns } from "./Goal.vue?vue&type=template&id=049e1d3c&scoped=true&"
import script from "./Goal.vue?vue&type=script&lang=ts&"
export * from "./Goal.vue?vue&type=script&lang=ts&"
import style0 from "./Goal.vue?vue&type=style&index=0&id=049e1d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e1d3c",
  null
  
)

export default component.exports